import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Nosotros from './pages/Nosotros';
import QuienesSomos from './pages/QuienesSomos';
import Integrantes from './pages/Integrantes';
import ComiteDirectivo from './pages/ComiteDirectivo';
import AvisoPrivacidad from './pages/AvisoPrivacidad';
import OficioReniecyt from './pages/nosotros/OficioReniecyt';
import PadronEditores from './pages/nosotros/PadronEditores';
import RegistroCaniem from './pages/nosotros/RegistroCaniem';
import RedRiel from './pages/RedRiel';
import Seminarios from './pages/Seminarios';
import SeminarioSNII from './pages/SeminarioSNII';
import EstanciasAcademicas from './pages/EstanciasAcademicas';
import NotFound from './pages/NotFound';
import DoctoradoInternacional from './pages/postgrados/DoctoradoInternacional';
import DiplomadoDetalle from './pages/diplomados/DiplomadoDetalle';
import { 
  Maestria, 
  Doctorado,
  Postdoctorados,
  LGACPostdoctorados,
  Antecedentes, 
  ModeloAcademico, 
  EstructuraOrganica, 
  Normatividad, 
  Aspirantes 
} from './pages/postgrados';
import { Congresos, CongresoPage } from './pages/congresos';
import AccesoCongresos from './pages/congresos/AccesoCongresos';
import { Revistas, ProcesoEditorial, RedesProduccion, PlantillaLibro, EjemploCapitulo, ColeccionLibros } from './pages/editorial';
import { Libros } from './pages/libros';
import { IACenidInvestigacion, IACenidProceso } from './pages/ia-cenid';
import { ProyectoUNITWIN, Conversatorio, RedUNADI, CatedraHome, QuienesSomos as CatedraQuienesSomos, Proyectos } from './pages/catedra-unesco';
import PlaceholderPage from './pages/PlaceholderPage';
import PoliticaCookies from './pages/PoliticaCookies';
import AdminPanel from './pages/AdminPanel';
import CertificacionesConocer from './pages/CertificacionesConocer';
import CelebracionGrammy from './pages/CelebracionGrammy';
import { Toaster } from './components/ui/sonner';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
  <CookieConsent />
        <div className="pt-[120px]"> {/* Account for fixed header height */}
          <Routes>
            <Route path="/" element={<Home />} />
            
            {/* Nosotros Routes */}
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/nosotros/quienes-somos" element={<QuienesSomos />} />
            <Route path="/nosotros/integrantes" element={<Integrantes />} />
            <Route path="/integrantes" element={<Integrantes />} />
            <Route path="/nosotros/comite-directivo" element={<ComiteDirectivo />} />
            <Route path="/comite-directivo" element={<ComiteDirectivo />} />
            <Route path="/nosotros/aviso-privacidad" element={<AvisoPrivacidad />} />
            <Route path="/aviso-privacidad" element={<AvisoPrivacidad />} />
            <Route path="/privacidad" element={<AvisoPrivacidad />} />
            <Route path="/politica-cookies" element={<PoliticaCookies />} />
            <Route path="/nosotros/oficio-reniecyt" element={<OficioReniecyt />} />
            <Route path="/nosotros/padron-nacional-editores" element={<PadronEditores />} />
            <Route path="/nosotros/registro-caniem" element={<RegistroCaniem />} />
            
            {/* RedRiel Routes */}
            <Route path="/redriel" element={<RedRiel />} />
            <Route path="/red-riel" element={<RedRiel />} />
            <Route path="/riel" element={<RedRiel />} />
            <Route path="/nosotros/redriel" element={<RedRiel />} />
            
            {/* Formación Routes */}
            <Route path="/formacion" element={<PlaceholderPage title="Formación" />} />
            <Route path="/formacion/maestria" element={<Maestria />} />
            <Route path="/maestria" element={<Maestria />} />
            <Route path="/formacion/doctorado" element={<Doctorado />} />
            <Route path="/doctorado" element={<Doctorado />} />
            <Route path="/formacion/doctorado-internacional" element={<DoctoradoInternacional />} />
            <Route path="/doctorado-internacional" element={<DoctoradoInternacional />} />
            <Route path="/formacion/postdoctorado" element={<Postdoctorados />} />
            <Route path="/postdoctorados" element={<Postdoctorados />} />
            <Route path="/lgac-postdoctorados" element={<LGACPostdoctorados />} />
            <Route path="/formacion/diplomados/:slug" element={<DiplomadoDetalle />} />
            
            {/* Postgrados Routes */}
            <Route path="/postgrados/maestria" element={<Maestria />} />
            <Route path="/postgrados/doctorado" element={<Doctorado />} />
            <Route path="/postgrados/postdoctorados" element={<Postdoctorados />} />
            <Route path="/postgrados/antecedentes" element={<Antecedentes />} />
            <Route path="/postgrados/modelo-academico" element={<ModeloAcademico />} />
            <Route path="/postgrados/estructura-organica" element={<EstructuraOrganica />} />
            <Route path="/postgrados/normatividad" element={<Normatividad />} />
            <Route path="/postgrados/aspirantes" element={<Aspirantes />} />
            
            {/* Legacy Routes (mantener compatibilidad) */}
            <Route path="/antecedentes" element={<Antecedentes />} />
            <Route path="/modelo-academico" element={<ModeloAcademico />} />
            <Route path="/estructura-organica" element={<EstructuraOrganica />} />
            <Route path="/normatividad" element={<Normatividad />} />
            <Route path="/aspirantes" element={<Aspirantes />} />
            
            {/* Congresos */}
            <Route path="/congresos" element={<Congresos />} />
            <Route path="/congresos/acceso" element={<AccesoCongresos />} />
            <Route path="/congresos/:id" element={<CongresoPage />} />
            
            {/* Editorial Routes */}
            <Route path="/editorial" element={<PlaceholderPage title="Editorial CENID" />} />
            <Route path="/editorial/revistas" element={<Revistas />} />
            <Route path="/editorial/redes" element={<RedesProduccion />} />
            <Route path="/redes" element={<RedesProduccion />} />
            <Route path="/redes-produccion" element={<RedesProduccion />} />
            <Route path="/editorial/proceso" element={<ProcesoEditorial />} />
            <Route path="/proceso-editorial" element={<ProcesoEditorial />} />
            <Route path="/editorial/proceso-editorial" element={<ProcesoEditorial />} />
            <Route path="/editorial/coleccion" element={<ColeccionLibros />} />
            <Route path="/editorial/plantillalibro" element={<PlantillaLibro />} />
            <Route path="/editorial/ejemplocapitulo" element={<EjemploCapitulo />} />
            
            {/* Libros Routes */}
            <Route path="/coleccion" element={<ColeccionLibros />} />
            <Route path="/coleccion/:year" element={<Libros />} />
            
            {/* IA CENID Routes */}
            <Route path="/ia-cenid" element={<Navigate to="/ia-cenid/investigacion" replace />} />
            <Route path="/ia-cenid/investigacion" element={<IACenidInvestigacion />} />
            <Route path="/ia-cenid/proceso" element={<IACenidProceso />} />
            <Route path="/upeace-cenid" element={<Navigate to="/ia-cenid/investigacion" replace />} />
            <Route path="/upeace" element={<Navigate to="/ia-cenid/investigacion" replace />} />
            
            {/* Other Routes */}
            <Route path="/redriel" element={<PlaceholderPage title="RedRiel" subtitle="Red de investigación" />} />
            
            {/* Cátedra UNESCO Routes */}
            <Route path="/catedra-unesco" element={<CatedraHome />} />
            <Route path="/catedra-unesco/quienes-somos" element={<CatedraQuienesSomos />} />
            <Route path="/catedra-unesco/proyectos" element={<Proyectos />} />
            <Route path="/catedra-unesco/unitwin" element={<ProyectoUNITWIN />} />
            <Route path="/catedra-unesco/catedra" element={<CatedraHome />} />
            <Route path="/catedra-unesco/conversatorio" element={<Conversatorio />} />
            <Route path="/conversatorio" element={<Conversatorio />} />
            {/* Legacy route (redirect to canonical) */}
            <Route path="/catedra-unesco/unadi" element={<Navigate to="/redunadi" replace />} />
            {/* Old alias route - redirect to canonical */}
            <Route path="/red-unadi" element={<Navigate to="/redunadi" replace />} />
            {/* New canonical route for Red UNADI */}
            <Route path="/redunadi" element={<RedUNADI />} />
            
            {/* Additional Routes */}
            <Route path="/postdoctorados" element={<PlaceholderPage title="Postdoctorados" subtitle="Programas de investigación" />} />
            <Route path="/revistas" element={<PlaceholderPage title="Revistas" subtitle="Publicaciones académicas" />} />
            <Route path="/redes" element={<PlaceholderPage title="Redes" subtitle="Redes de colaboración" />} />
            <Route path="/seminarios" element={<Seminarios />} />
            <Route path="/seminario-snii" element={<SeminarioSNII />} />
            <Route path="/estancias" element={<EstanciasAcademicas />} />
            <Route path="/estancias-academicas" element={<EstanciasAcademicas />} />
            <Route path="/coleccion-editorial" element={<PlaceholderPage title="Colección Editorial" subtitle="Libros publicados" />} />
            <Route path="/terminos" element={<PlaceholderPage title="Términos y Condiciones" />} />
            
            {/* Celebración GRAMMY */}
            <Route path="/celebracion-grammy" element={<CelebracionGrammy />} />
            <Route path="/noticias/grammy-cenid" element={<CelebracionGrammy />} />

            {/* Certificaciones CONOCER */}
            <Route path="/certificaciones" element={<CertificacionesConocer />} />
            <Route path="/certificaciones-conocer" element={<CertificacionesConocer />} />
            <Route path="/conocer" element={<CertificacionesConocer />} />
            <Route path="/formacion/certificaciones" element={<CertificacionesConocer />} />
            
            {/* Admin Panel */}
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/admin-panel" element={<AdminPanel />} />
            
            {/* 404 - Catch all route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
        <WhatsAppButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
